const appBaseRoute = 'spil';

const routes = {
  category: {
    url: `${appBaseRoute}/:category?`,
  }
};

export default routes;
